/**
 * Theme Requirements Aggregation for Axia Residential Arc Living
 * 
 * Extends the base preferred theme requirements with Axia Residential Arc Living specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-preferred/requirements';

/**
 * Axia Residential Arc Living component requirement overrides.
 * Add requirements for any override components here.
 */
const axiaresidentialarclivingOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Axia Residential Arc Living theme.
 * Inherits from preferred theme and overrides with Axia Residential Arc Living components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...axiaresidentialarclivingOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
